import React from 'react';
import { Page } from '../Page';
import { Zap, Droplet, Award } from 'lucide-react';
export function SupplementWheyProtein() {
  return <Page pageNumber={10} variant="light" data-id="element-3181">
      <div className="flex h-full gap-10" data-id="element-3182">
        {/* Left: Product Image */}
        <div className="w-[40%] flex flex-col items-center justify-center" data-id="element-3183">
          <img src="https://cdn.magicpatterns.com/uploads/rz95qpTVrA12dEB643rF4b/pasted-image.png" alt="Thorne Whey Protein Isolate" className="w-full max-w-[280px] object-contain" data-id="element-3184" />
        </div>

        {/* Right: Content */}
        <div className="w-[60%] flex flex-col" data-id="element-3185">
          <div className="mb-6 pt-4" data-id="element-3186">
            <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-3187">
              Supplement Spotlight
            </p>
            <h1 className="text-4xl font-serif text-[#1F1F1F] leading-tight mb-3" data-id="element-3188">
              Whey Protein Isolate
            </h1>
            <p className="text-lg text-tealslate font-serif italic mb-4" data-id="element-3189">
              Hit your protein goals when appetite is low
            </p>
            <div className="w-16 h-0.5 bg-tealslate" data-id="element-3190" />
          </div>

          <div className="mb-8" data-id="element-3191">
            <h2 className="text-sm font-bold text-[#1F1F1F] mb-3 uppercase tracking-wider" data-id="element-3192">
              Why It Matters on GLP-1
            </h2>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-4" data-id="element-3193">
              When appetite is suppressed and portions are small, a high-quality
              protein shake is often the most practical way to hit 80-100g+
              daily targets. At 21g protein per scoop in just 100 calories, this
              is an extremely efficient protein-to-calorie ratio.
            </p>
          </div>

          <div className="mb-8" data-id="element-3194">
            <h3 className="text-xs font-bold text-[#1F1F1F] mb-3" data-id="element-3195">
              Key Benefits
            </h3>
            <ul className="space-y-2 text-xs text-[#7A7A70] leading-[1.7]" data-id="element-3196">
              <li className="flex gap-2" data-id="element-3197">
                <Zap className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3198" />
                <span data-id="element-3199">
                  Preserves lean mass during weight loss with complete amino
                  acid profile
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3200">
                <Droplet className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3201" />
                <span data-id="element-3202">
                  Includes bromelain + papain digestive enzymes (helpful for
                  GLP-1 users with slowed digestion)
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3203">
                <Award className="w-4 h-4 text-tealslate shrink-0 mt-0.5" data-id="element-3204" />
                <span data-id="element-3205">
                  Whey isolate = easier digestion, lower lactose, NSF Certified
                  for Sport
                </span>
              </li>
              <li className="flex gap-2" data-id="element-3206">
                <span className="text-tealslate shrink-0" data-id="element-3207">•</span>
                <span data-id="element-3208">
                  Easy to consume when solid food feels difficult. Mix with
                  water, milk, or smoothies
                </span>
              </li>
            </ul>
          </div>

          <div className="mt-auto" data-id="element-3209">
            <div className="bg-[#EAEAE4] border border-[#D8D8D0] p-5 mb-4" data-id="element-3210">
              <h3 className="text-xs font-bold text-[#1F1F1F] mb-2 uppercase tracking-wider" data-id="element-3211">
                Dosage
              </h3>
              <p className="text-sm text-[#3B3B3B] mb-1" data-id="element-3212">
                <strong data-id="element-3213">1 scoop (30.2g)</strong> with at least 8oz liquid daily
              </p>
              <p className="text-xs text-[#7A7A70]" data-id="element-3214">
                ~30 servings per 906g tub • 21g protein, 100 calories per
                serving
              </p>
            </div>

            <div className="flex items-center gap-3" data-id="element-3215">
              <img src="https://cdn.magicpatterns.com/uploads/apjpXQduRziER6ah2LWfcy/url_qrcodecreator.com_15_15_43.png" alt="Fullscript QR Code" className="w-12 h-12 shrink-0" data-id="element-3216" />
              <p className="text-[10px] text-[#7A7A70] italic leading-[1.5]" data-id="element-3217">
                If you're interested in a supplement plan tailored to you, check
                out the link below! Fullscript provides third-party tested, safe
                and effective supplements to help get your health where you want
                it at wholesale prices.
              </p>
            </div>
          </div>
        </div>
      </div>
    </Page>;
}